import dayjs from 'dayjs'

import type { AnalyticsParamsRange } from '../../../modules/AnalyticsParams'

export const getEndDateFromRange = (range?: AnalyticsParamsRange): string | undefined => {
  if (!range) return

  const to = dayjs(range.to).utc()

  return `As of ${to.format('MMM D')}`
}
